export async function compressImage(file, maxWidth, maxHeight, quality) {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx    = canvas.getContext("2d");
    const img    = new Image();
    img.onload = () => {
      let { width, height } = img;
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width  = Math.round(width  * ratio);
        height = Math.round(height * ratio);
      }
      canvas.width  = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => resolve(new File([blob], file.name.replace(/\.[^.]+$/, ".webp"), { type: "image/webp" })),
        "image/webp",
        quality
      );
    };
    img.src = URL.createObjectURL(file);
  });
}
